import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'my_hp_role',

  can: {
    route() {
      return this.child && (this.isAdmin() || this.isMyHp() || this.isMDT());
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/MyHpPerimeter.js